import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import NewUserModalContainer from './NewUserModalContainer';
import usersConfigShape from '../../../shapes/usersConfigShape';
import usersConfigEditShape from '../../../shapes/usersConfigEditShape';
import editUserSchema from '../../../schemas/editUser';
import TableWithFetch from '../../reusable/TableWithFetch';

const SettingsUsers = (props) => {
  const {
    t, getUsers, users, openNewUserModal, loadMore,
    openEditUserModal, closeEditUserModal, updateUser,
    openDeleteUserModal, closeDeleteUserModal, deleteUser,
  } = props;
  const {
    isPending, isAddModalOpen, validation, isPendingUpdate, isPendingDelete,
  } = users;
  return (
    <TableWithFetch
      fetchAction={getUsers}
      isLoading={isPending}
      content={users}
      shape={usersConfigShape}
      loadMoreAction={() => loadMore()}
      editable
      withAddButton={{
        iconName: 'user',
        label: t('common.add'),
        isModalOpen: isAddModalOpen,
        openModalAction: openNewUserModal,
        containerElem: NewUserModalContainer,
      }}
      openEditModalAction={openEditUserModal}
      editModalProps={{
        closeModalAction: closeEditUserModal,
        updateItemAction: updateUser,
        isPending: isPendingUpdate,
        titleFormat: '%s %s',
        titleValues: ['firstName', 'lastName'],
        shape: usersConfigEditShape,
        schema: editUserSchema,
        validation,
        size: 'tiny',
        btnText: t('common.add'),
      }}
      openDeleteModalAction={openDeleteUserModal}
      deleteModalProps={{
        closeModalAction: closeDeleteUserModal,
        deleteAction: deleteUser,
        isPending: isPendingDelete,
        textFormat: t('usersConfig.delete?'),
        textValues: ['firstName', 'lastName'],
        title: t('common.delete'),
      }}
    />
  );
};

SettingsUsers.propTypes = {
  t: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  loadMore: PropTypes.func.isRequired,
  users: PropTypes.shape({}).isRequired,
  openNewUserModal: PropTypes.func.isRequired,
  openEditUserModal: PropTypes.func.isRequired,
  closeEditUserModal: PropTypes.func.isRequired,
  openDeleteUserModal: PropTypes.func.isRequired,
  closeDeleteUserModal: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
};

export default translate()(SettingsUsers);



// WEBPACK FOOTER //
// ./src/components/Settings/users/SettingsUsers.js